class OrdinController extends AbstractIntegrationController
	@register()
	@inject '$window',
		'configuration'
		'IntegrationRepository'

	integrationId: 'ordin'

	initialize: ->
		@additionalButtonsTemplate = '@app/integration/ordin/ordin.additional-buttons.view.html'

	save: ->
		super(@configuration)
			.then =>
				@IntegrationRepository
					.getConfiguration(@integrationId)
					.then (response) =>
						@configuration = response.data

	afterDisconnect: ->
		@configuration = {}

	goToOrdinBackoffice: ->
		@IntegrationRepository
			.fetch("/#{@integrationId}/backoffice/access")
			.then (response) =>
				@$window.open(response.data.url, '_ordin_backoffice')
			.catch =>
				@ToastService.add(
					@$filter('translate')(@headerText).toString(),
					@$filter('translate')('general.integration'),
					@$filter('translate')('general.error'),
					'error'
				)
